import React from "react";
import PageHeader from "../../components/common/PageHeader";
import EnquiryForConsultant from "../../components/Consultant User Side/EnquiryForConsultant";

const ConsultantUser = () => {
  return (
    <div>
      <PageHeader pageName={"Consultant Registration Form"} />
      <EnquiryForConsultant />
    </div>
  );
};

export default ConsultantUser;
